"use strict";
exports.f = Object.getOwnPropertySymbols;
